export const PhoneVerificationIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            fill="none"
            viewBox="0 0 304 212"
        >
            <g filter="url(#a)" opacity=".05">
                <rect
                    width="82.774"
                    height="159.917"
                    fill="#394855"
                    rx="9"
                    transform="matrix(.86603 -.5 .86603 .5 46.466 118.214)"
                />
            </g>
            <g opacity=".1">
                <mask id="b" fill="#fff">
                    <path
                        fillRule="evenodd"
                        d="M15.588 80c-4.557-2.631-6.702-6.128-6.434-9.574v-8.89H14v1.484A19.394 19.394 0 0 1 15.588 62l76.21-44c8.61-4.97 22.568-4.97 31.178 0l164.545 95c.564.326 1.091.665 1.581 1.015v-1.284h4.846v8.613a7.37 7.37 0 0 1 0 1.312v.004c-.271 3.034-2.414 6.023-6.427 8.34l-76.211 44c-8.609 4.971-22.567 4.971-31.177 0L15.589 80Z"
                        clipRule="evenodd"
                    />
                </mask>
                <path
                    fill="#394855"
                    fillRule="evenodd"
                    d="M15.588 80c-4.557-2.631-6.702-6.128-6.434-9.574v-8.89H14v1.484A19.394 19.394 0 0 1 15.588 62l76.21-44c8.61-4.97 22.568-4.97 31.178 0l164.545 95c.564.326 1.091.665 1.581 1.015v-1.284h4.846v8.613a7.37 7.37 0 0 1 0 1.312v.004c-.271 3.034-2.414 6.023-6.427 8.34l-76.211 44c-8.609 4.971-22.567 4.971-31.177 0L15.589 80Z"
                    clipRule="evenodd"
                />
                <path
                    fill="#394855"
                    d="m9.154 70.426.997.077.003-.038v-.04h-1ZM15.588 80l-.5.866.5-.866ZM9.154 61.535v-1h-1v1h1Zm4.846 0h1v-1h-1v1Zm0 1.485h-1v1.946l1.582-1.133L14 63.02ZM15.588 62l-.5-.866.5.866Zm76.21-44-.5-.866.5.866Zm31.178 0-.5.866.5-.866Zm164.545 95 .5-.866-.5.866Zm1.581 1.015-.581.814 1.581 1.131v-1.945h-1Zm0-1.284v-1h-1v1h1Zm4.846 0h1v-1h-1v1Zm0 8.613h-1v.044l.004.044.996-.088Zm0 1.312-.996-.088-.004.044v.044h1Zm0 .004v1h1v-1h-1Zm0 0v-1h-.915l-.081.911.996.089Zm-6.427 8.34.5.866-.5-.866Zm-76.211 44 .5.866-.5-.866Zm-31.177 0 .5-.866-.5.866ZM8.157 70.348c-.309 3.97 2.181 7.776 6.931 10.518l1-1.732c-4.364-2.52-6.164-5.708-5.937-8.63l-1.994-.156Zm-.003-8.813v8.89h2v-8.89h-2Zm5.846-1H9.154v2H14v-2Zm1 2.485v-1.485h-2v1.485h2Zm.088-1.886c-.593.343-1.15.7-1.67 1.073l1.164 1.626c.464-.332.966-.655 1.506-.967l-1-1.732Zm76.21-44-76.21 44 1 1.732 76.21-44-1-1.732Zm32.178 0c-4.493-2.594-10.318-3.862-16.089-3.862-5.771 0-11.596 1.268-16.088 3.862l1 1.732c4.117-2.377 9.575-3.594 15.088-3.594s10.972 1.217 15.089 3.594l1-1.732Zm164.545 95-164.545-95-1 1.732 164.545 95 1-1.732Zm1.663 1.068a20.304 20.304 0 0 0-1.663-1.068l-1 1.732c.537.31 1.037.632 1.5.963l1.163-1.627Zm.418.813v-1.284h-2v1.284h2Zm-1-.284h4.846v-2h-4.846v2Zm3.846-1v8.613h2v-8.613h-2Zm1.996 10.014a8.426 8.426 0 0 0 0-1.49l-1.992.177c.034.379.034.757 0 1.136l1.992.177Zm-1.996-.089v.004h2v-.004h-2Zm1-.996v2-2Zm-5.927 10.206c4.184-2.416 6.613-5.649 6.923-9.117l-1.992-.178c-.232 2.6-2.089 5.344-5.931 7.563l1 1.732Zm-76.211 44 76.211-44-1-1.732-76.211 44 1 1.732Zm-32.177 0c4.493 2.594 10.318 3.862 16.089 3.862 5.771 0 11.596-1.268 16.088-3.862l-1-1.732c-4.117 2.377-9.575 3.594-15.088 3.594s-10.972-1.217-15.089-3.594l-1 1.732Zm-164.544-95 164.544 95 1-1.732-164.544-95-1 1.732Z"
                    mask="url(#b)"
                />
            </g>
            <rect
                width="123"
                height="225"
                x=".866"
                fill="#fff"
                stroke="#E2E5E7"
                rx="17.5"
                transform="matrix(.86603 -.5 .86603 .5 .116 62.433)"
            />
            <path
                fill="#394855"
                d="M125.264 57.823c2.483 1.434 4.174 3.26 4.859 5.249.686 1.989.334 4.05-1.01 5.923-1.344 1.873-3.62 3.474-6.54 4.601-2.92 1.126-6.353 1.728-9.865 1.728-3.512 0-6.945-.602-9.865-1.728-2.92-1.127-5.196-2.728-6.54-4.6-1.344-1.874-1.695-3.935-1.01-5.924.685-1.989 2.376-3.815 4.859-5.25 3.33-1.922 7.847-3.002 12.556-3.002 4.709 0 9.226 1.08 12.556 3.003ZM117.73 76.67c-3.33 1.922-5.2 4.53-5.2 7.248 0 2.72 1.87 5.327 5.2 7.25 1.608.928 3.806 1.439 5.991 1.076 4.171-.693 11.841-2.673 21.632-8.326 9.791-5.652 13.219-10.08 14.42-12.489.629-1.261-.256-2.53-1.864-3.458-3.33-1.923-7.847-3.003-12.556-3.003-4.709 0-9.226 1.08-12.556 3.003L117.73 76.67Z"
                opacity=".3"
            />
            <path
                stroke="url(#c)"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m169.481 95.625 7.145 4.125M160.622 108h10.097m-1.238 12.375 7.145-4.125m14.289 9.24v-5.83m14.29-3.41 7.144 4.125m8.86-12.375h-10.098m1.238-12.375-7.144 4.125m-14.29-9.24v5.83"
                opacity=".3"
            />
            <rect
                width="109.523"
                height="212.527"
                x=".866"
                stroke="#F3F5F7"
                rx="8.5"
                transform="matrix(.86603 -.5 .86603 .5 11.353 62.182)"
            />
            <rect
                width="42.265"
                height="7.83"
                fill="#C4C8CC"
                rx="3.915"
                transform="matrix(.86603 -.5 .86603 .5 40.794 44.685)"
            />
            <defs>
                <linearGradient
                    id="c"
                    x1="190.915"
                    x2="190.915"
                    y1="92.077"
                    y2="124.147"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#D43527" />
                    <stop offset="1" stopColor="#D43527" stopOpacity="0" />
                </linearGradient>
                <filter
                    id="a"
                    width="233.045"
                    height="148.073"
                    x="35.032"
                    y="63.463"
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur result="effect1_foregroundBlur_853_282" stdDeviation="8" />
                </filter>
            </defs>
        </svg>
    );
};
